import { PopupDirection } from 'lego-on-react';
import React from 'react';

import { PicturePopup } from '../PicturePopup/PicturePopup';
import { QuestionLink } from '../QuestionLink/QuestionLink';

interface Props {
    src: string;
    directions?: PopupDirection[];
}

export const PictureHint: React.FC<Props> = ({ src, directions }) => {
    return (
        <PicturePopup src={src} directions={directions}>
            <QuestionLink />
        </PicturePopup>
    );
};
